/*
 * Fix the Adobe flash z-index issue in IE.
 */
(function ($) {

    function fixFlashIE() {
        //var frames = document.getElementsByTagName("iframe");
        var frames = $('#main iframe');
        for (var i = 0; i < frames.length; i++) {
            var src = frames[i].src;
            if (src) {
                var q = src.indexOf('?') >= 0 ? '&' : '?';
                frames[i].src += q + "wmode=opaque";
            }
        }
    }

    var ua = window.navigator.userAgent;
    var msie = ua.indexOf('MSIE ');
    if (msie > 0) {
        // IE 10 or older
        $(fixFlashIE);
    }

    var trident = ua.indexOf('Trident/');
    if (trident > 0) {
        // IE 11
        $(fixFlashIE);
    }

    var edge = ua.indexOf('Edge/');
    if (edge > 0) {
        // Edge (IE 12+)
        $(fixFlashIE);
    }

})(jQuery);
